import React from 'react';

import {Box, Paper, Stack, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import PlanPriceCard from './PlanPriceCard';

const PlansCard = () => {
  const planItems = [
    {
      recommended: true,
      title: translate('schedulestep.PlansCard.QuarterlyTitle'),
      subtitle: translate('schedulestep.PlansCard.QuarterlySubtitle'),
      description: translate('schedulestep.PlansCard.QuarterlyDescription'),
    },
    {
      title: translate('schedulestep.PlansCard.MonthToMonthTitle'),
      subtitle: translate('schedulestep.PlansCard.MonthToMonthSubtitle'),
      description: translate('schedulestep.PlansCard.MonthToMonthDescription'),
    },
    {
      title: translate('schedulestep.PlansCard.WeekToWeekTitle'),
      subtitle: translate('schedulestep.PlansCard.WeekToWeekSubtitle'),
      description: translate('schedulestep.PlansCard.WeekToWeekDescription'),
    },
  ];

  return (
    <Paper
      sx={{
        p: '32px',
        borderRadius: '24px',
        boxShadow: 'none',
      }}
    >
      <Stack sx={{gap: '32px'}}>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
          <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
            <Translate expression={'schedulestep.PlansCard.Title'} />
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '150%',
              color: '#2D2925',
            }}
          >
            <Translate expression={'schedulestep.PlansCard.Description'} />
          </Typography>
        </Box>

        <Stack sx={{gap: '16px'}}>
          {
            planItems.map((item) => (
              <PlanPriceCard
                key={item.title}
                title={item.title}
                subtitle={item.subtitle}
                description={item.description}
                recommended={item.recommended}
              />
            ))
          }
        </Stack>

        <Typography
          sx={{
            fontSize: '16px',
            lineHeight: '150%',
            fontWeight: 400,
            color: '#2D2925A3',
          }}
        >
          <Translate expression={'schedulestep.PlansCard.PricingNote'} />
        </Typography>
      </Stack>
    </Paper>
  );
};

export default React.memo(PlansCard);
